<template>
  <div>
    <span>{{ title }}</span>
    <ul>
      <li class="agent-name" v-for="item in orderedItems" :key="item.id">{{ item.name }}</li>
    </ul>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';

export default {
  name: 'EcsAssignedAgents',
  props: {
    items: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    orderedItems() {
      const orderedItems = cloneDeep(this.items);
      orderedItems.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
      return orderedItems;
    }
  }
};
</script>

<style scoped>
.agent-name {
  font-size: 14px;
}
</style>
